import { RefreshCw } from "lucide-react";

export default function LoadingOverlay({
  title = "Analyse en cours...",
  description = "Cela peut prendre quelques instants.",
}) {
  return (
    <div className="fixed inset-0 bg-stone-900/60 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full text-center flex flex-col items-center ring-1 ring-stone-200">
        <RefreshCw className="animate-spin text-blue-500 mb-6" size={48} />
        <h2 className="text-xl font-semibold text-stone-900 mb-2">{title}</h2>
        <p className="text-stone-500 text-sm leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
